declare const __FACTURE_BUILD_ID__: string

const BUILD_ID = typeof __FACTURE_BUILD_ID__ === 'string' ? __FACTURE_BUILD_ID__ : 'dev'
const RELOAD_KEY = 'facture:build-reload'
const CHECK_EVERY_MS = 30_000

/**
 * Recarga la pestaña cuando el contenedor que está sirviendo no es el build que cargó esta página.
 * Cada imagen Docker trae otro id en el JS y en `/version.json`. Si no coinciden, el navegador pide de
 * nuevo el index y los assets. Como máximo dos recargas por minuto, para no entrar en un ciclo si un
 * proxy sigue entregando el HTML viejo.
 */
export function watchForNewBuild(): void {
  if (import.meta.env.DEV || BUILD_ID === 'dev') return

  const reload = () => {
    const now = Date.now()
    const [at, count] = (sessionStorage.getItem(RELOAD_KEY) ?? '').split(':')
    const recent = now - Number(at) < 60_000
    const n = recent ? Number(count) : 0
    if (n >= 2) return
    sessionStorage.setItem(RELOAD_KEY, `${now}:${n + 1}`)
    location.reload()
  }

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reload()
  })

  const check = async () => {
    try {
      const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
      if (!res.ok) return
      const body = (await res.json()) as { version?: unknown }
      if (typeof body.version !== 'string' || body.version.length === 0) return
      if (body.version === BUILD_ID) {
        sessionStorage.removeItem(RELOAD_KEY)
        return
      }
      reload()
    } catch {
      // El contenedor está reiniciando o la red falló: se reintenta en el próximo ciclo.
    }
  }

  void check()
  window.addEventListener('focus', () => void check())
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void check()
  })
  window.setInterval(() => void check(), CHECK_EVERY_MS)
}
